module.exports = function getResource(label, vars = []) {
    let resources = {
        defaultCard: 'Default Card',
        expires: 'Expires',
        payPalAccount: 'PayPal Account',
        payWithPayPal: 'Pay with PayPal',
        payWithApplePay: 'Pay with ApplePay',
        payWithKlarna: 'Pay with 4 interest-free installments',
        storeCreditApplied: 'Account Credit Applied',
        endingIn: 'ending in',
        klarnaDisabled: `${vars[0]} cannot be used for Gift Cards, Flash, Subscription, or In-store Appointment purchases; with Sephora Credit Card Rewards; or on orders with a total of $1000 or more.`
    };

    return resources[label];
};
